import type { MobVisualConfig } from './MobVisualArchetypes';

/** Named encounters (optional branches and quest elites) share established motion and telegraph behavior. */
export const BRANCH_MOB_VISUALS: Readonly<Record<string, MobVisualConfig>> = {
  forest_hollow_crown: {
    archetype: 'lumberer',
    art: { svgKey: 'forest_hollow_crown', tint: 0xffffff },
    idle: { bobAmpPx: .25, bobPeriodMs: 3800, sway: .65 },
    hitReact: { recoilPx: 2, squash: .07 },
    death: { mode: 'sink', durMs: 950 },
    telegraph: { tellMs: 800, cue: 'crouch' },
    vibe: { auraColor: 0xc6a46b, auraAlpha: .06, particleKind: 'heavy_dust' },
  },
  glowspore_keeper: {
    archetype: 'lumberer',
    art: { svgKey: 'glowspore_keeper', tint: 0xffffff },
    idle: { bobAmpPx: .5, bobPeriodMs: 3200, sway: .5 },
    hitReact: { recoilPx: 2, squash: .08 },
    death: { mode: 'shatter', durMs: 900 },
    telegraph: { tellMs: 700, cue: 'crouch' },
    vibe: { auraColor: 0x8edec5, auraAlpha: .1, particleKind: 'spore' },
  },
  blightroot_alpha: {
    // The corruption chain's finale: heavier than its dark_stump kin, a
    // brighter aura and a longer crouch before the eruption.
    archetype: 'lumberer',
    art: { svgKey: 'blightroot_alpha', tint: 0xffffff },
    idle: { bobPeriodMs: 4400, sway: 2.5 },
    hitReact: { recoilPx: 2, squash: .06 },
    death: { mode: 'shatter', durMs: 1200 },
    telegraph: { tellMs: 900, cue: 'crouch' },
    vibe: { auraColor: 0x39ff88, auraAlpha: .16, particleKind: 'root_chips' },
  },
};
